export { App as default } from '@guiker/notification-main-mfe'
